// extracted by mini-css-extract-plugin
export default {"container":"CardColaborador_container__WGyov","btn":"CardColaborador_btn__BUpv+"};